import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  toggleSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();

}
